import { useEffect } from 'react';

import styles from './Toast.module.css';
import { useToastStore } from './toastStore';


const VARIANT_ICON: Record<'success' | 'error' | 'info', string> = {
  success: '✓',
  error: '!',
  info: 'i',
};

const AUTO_DISMISS_MS = 4_000;

/**
 * 토스트 렌더러.
 *
 * - 페이지 우측 상단에 고정되어, 스토어에 쌓인 토스트를 순서대로 보여준다.
 * - 각 토스트는 `AUTO_DISMISS_MS`(4초) 후 자동으로 dismiss된다.
 * - `aria-live="polite"`로 보조기기에 알림이 전달된다.
 */
export function Toaster(): React.JSX.Element {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  useEffect(() => {
    if (toasts.length === 0) {
      return;
    }
    const timers = toasts.map((t) =>
      window.setTimeout(() => dismiss(t.id), AUTO_DISMISS_MS),
    );
    return () => {
      timers.forEach((id) => window.clearTimeout(id));
    };
  }, [toasts, dismiss]);

  return (
    <div className={styles.container} role="region" aria-live="polite" aria-label="알림">
      {toasts.map((t) => (
        <div key={t.id} className={`${styles.toast} ${styles[t.variant]}`}>
          <div className={styles.icon} aria-hidden>
            {VARIANT_ICON[t.variant]}
          </div>
          <div className={styles.message}>{t.message}</div>
          <button
            type="button"
            className={styles.close}
            onClick={() => dismiss(t.id)}
            aria-label="알림 닫기"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
